import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

import Loader from '../loader/loader';

const CustomButton = ({
  title,
  variant = 'primary',
  className = '',
  loading = false,
  ...props
}) => {
  const getButtonClasses = () => {
    switch (variant) {
      case 'outline':
        return 'btn-primary-outline';
      case 'danger':
        return 'btn-primary-red text-white';
      default:
        return 'btn-primary-blue border-none text-white';
    }
  };
  return (
    <Button
      className={`button-common radius-2 manrope-14-regular w-100 ${getButtonClasses()} ${className}`}
      {...props}
    >
      {loading ? <Loader /> : title}
    </Button>
  );
};

CustomButton.propTypes = {
  title: PropTypes.node.isRequired,
  variant: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.bool
};

export default React.memo(CustomButton);